import {
    AUSTRALIA_COUNTRY_CODE,
    CALIFORNIA_REGION_CODE,
    CANADA_COUNTRY_CODE,
    ISRAEL_COUNTRY_CODE,
    MINNESOTA_REGION_CODE,
    NEW_YORK_REGION_CODE,
    NORWAY_COUNTRY_CODE,
    UNITED_KINGDOM_COUNTRY_CODE,
    US_COUNTRY_CODE,
} from '../countryCodes.constants';

export const REGULATED_COUNTRY_CODES = [
    US_COUNTRY_CODE,
    CANADA_COUNTRY_CODE,
    UNITED_KINGDOM_COUNTRY_CODE,
    ISRAEL_COUNTRY_CODE,
    NORWAY_COUNTRY_CODE,
    AUSTRALIA_COUNTRY_CODE,
] as const;
export const REGULATED_US_REGION_CODES = [CALIFORNIA_REGION_CODE, MINNESOTA_REGION_CODE, NEW_YORK_REGION_CODE];

export interface RegulatedCountry {
    regions?: string[];
}

type RegulationConfig = {
    [key in (typeof REGULATED_COUNTRY_CODES)[number]]: RegulatedCountry;
};

export const REGULATION_CONFIG: RegulationConfig = {
    [US_COUNTRY_CODE]: {
        regions: REGULATED_US_REGION_CODES,
    },
    [CANADA_COUNTRY_CODE]: {},
    [UNITED_KINGDOM_COUNTRY_CODE]: {},
    [ISRAEL_COUNTRY_CODE]: {},
    [NORWAY_COUNTRY_CODE]: {},
    [AUSTRALIA_COUNTRY_CODE]: {},
} as const;
